module.exports = __webpack_public_path__ + "img/whatsapp-icon-portfolio.3f2184d6.svg";